import React from 'react';
import { CSSTransition } from 'react-transition-group'

export const FadeTransition = (props) => (
    <CSSTransition
        {...props}
        classNames="fade-in"
        timeout={{ enter: 150, exit: 150 }}
    />
);

export const SlideUpTransition = (props) => {
    return (
        <CSSTransition
            {...props}
            classNames="slide-up"
            timeout={{ enter: 150, exit: 300 }}
        />
    )
}

export const ZoomInTransition = (props) => {
    return (
        <CSSTransition
            {...props}
            classNames="zoom-in"
            timeout={{ enter: 500, exit: 500 }}
        />
    )
}